export const formatToCZK = (value: number) =>
	`${Intl.NumberFormat('cs-CZ', {
		style: 'currency',
		currency: 'CZK',
	}).format(value)}`;
